module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/head-m-01f00480dc4218df59c6bb4a8316d0d2.png";